import { createContext } from 'react';
import {
  ClassificationGroupView,
  FeatureClassificationView,
  FeatureDefinitionView,
} from '../../../generated/ApiClient';

export interface ClassificationGroupMap {
  id: string;
  name: string;
  parentGroupId?: string;
  children: ClassificationGroupMap[];
}

export interface ClassificationState {
  features: FeatureDefinitionView[];
  groupMap: ClassificationGroupMap[];
  groups: ClassificationGroupView[];
  selectedGroup: ClassificationGroupView | null;
  featureClassifications: FeatureClassificationView[];
  isFeaturesLoading: boolean;
  isGroupsLoading: boolean;
  refetchFeatures: () => void;
  refetchGroups: () => void;
  setSelectedGroupId: (id: string | null) => void;
}

export const ClassificationContext = createContext<ClassificationState>({
  features: [],
  groups: [],
  groupMap: [],
  isFeaturesLoading: false,
  refetchFeatures: () => {},
  refetchGroups: () => {},
  isGroupsLoading: false,
  selectedGroup: null,
  featureClassifications: [],
  setSelectedGroupId: (id: string | null) => {},
});

export function buildClassificationGroupMap(
  flatGroups: ClassificationGroupView[]
): ClassificationGroupMap[] {
  const groupMap = new Map<string, ClassificationGroupMap>();

  flatGroups.forEach((group) => {
    groupMap.set(group.id, {
      id: group.id,
      name: group.name,
      parentGroupId: group.parentGroupId,
      children: [],
    });
  });

  const rootGroups: ClassificationGroupMap[] = [];

  flatGroups.forEach((group) => {
    const groupMapItem = groupMap.get(group.id)!;

    if (group.parentGroupId) {
      const parent = groupMap.get(group.parentGroupId);
      if (parent) {
        parent.children.push(groupMapItem);
      }
    } else {
      rootGroups.push(groupMapItem);
    }
  });

  return rootGroups;
}
